import type { ProviderService } from '../../../../api/Providers/Services';

export function getTopBookableServiceId(providerServices: ProviderService[]): number {
  const bookableServices = (providerServices || []).filter(service => service.is_online_bookable);

  const popularServices = bookableServices
    .filter(service => typeof service.popularity_percentage === 'number')
    .sort((a, b) => b.popularity_percentage - a.popularity_percentage);

  if (popularServices.length) {
    return popularServices[0].id;
  }

  if (bookableServices.length) {
    return bookableServices[0].id;
  }

  return null;
}
